import moment from 'moment';

/**
 * Extracts and formats the day and time from given date strings.
 * @param {string} date - Date string.
 * @param {string} timezone - Timezone string.
 * @returns {Object} An object containing formatted day and time.
 */

const formatDateAndTime = (date, timezone) => {
  const day = typeof date === 'string' ? moment.tz(date, timezone).format('MMMM Do') : null;
  const time = typeof date === 'string' ? moment.tz(date, timezone).format('h:mma (z)') : null;

  const formattedDay = day || 'Invalid date';
  const formattedTime = time || 'Invalid date';

  return { formattedDay, formattedTime };
};

export default formatDateAndTime;
